import React from "react";
import FamilyNoteContainer from "../Notes/FamilyNoteContainer";
import { useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { incrementDailyReads } from "../../logsComponents/incrementDailyReads";

function FamilyNotesContainer(props) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (props.clientId) {
      const notesRef = collection(db, "notes");
      const q = query(
        notesRef,
        where("noteType", "==", "familyNote"),
        where("clientId", "==", props.clientId),
        orderBy("effectiveDateTime", "desc"),
        limit(50)
      );

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const notesData = [];
        querySnapshot.forEach((doc) => {
          notesData.push({ id: doc.id, ...doc.data() });
        });
        setLoading(false);
        setNotes(notesData);
        try { incrementDailyReads("notes_family_client", querySnapshot.size); } catch {}
      });

      return () => {
        unsubscribe();
      };
    }
  }, [props.clientId]);

  return (
    <div className="notes-container-global">
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
          <p>Loading, please wait...</p>
        </div>
      ) : (
        notes.map((note) => {
          const dateOptions = {
            day: "numeric",
            month: "short",
            year: "numeric",
          };

          const dateOptions2 = {
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          };

          const timeOptions = {
            hour: "2-digit",
            minute: "2-digit",
          };

          const formattedTimestamp = note.createdAt
            ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                note.createdAt.toDate()
              )
            : "";

          const formattedLastModification = note.updateAt
            ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                note.updateAt.toDate()
              )
            : "";

          const formattedDate = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", dateOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          const formattedTime = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", timeOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          return (
            <div style={{ paddingBottom: "15px" }}>
              <FamilyNoteContainer
                key={note.id}
                noteContent={note.noteContent}
                effectiveDate={note.effectiveDateTime}
                noteDate={formattedDate}
                noteTime={formattedTime}
                doneBy={note.doneBy}
                timeStamp={formattedTimestamp}
                lastModification={formattedLastModification}
                clientPic={note.clientProfilePicture}
                clientFirstName={note.clientFirstName}
                clientLastName={note.clientLastName}
                noteId={note.id}
                relationship={note.relationShipFamilyNote}
                relationshipOther={note.relationShipFamilyNoteOther}
                fileUrls={note.fileUrls}
                {...note}
              />
            </div>
          );
        })
      )}
    </div>
  );
}

export default FamilyNotesContainer;
